const REQUEST_TIMEOUT_MS = 2000;

let sdk = null;
let initialization = null;

function readSdkKey() {
  if (typeof window === 'undefined') return '';

  return window.px_config?.experiments?.configCat?.sdkKey ?? '';
}

export const configCatFeatureFlagProvider = {
  isAvailable() {
    return readSdkKey() !== '';
  },

  async initialize() {
    if (!initialization) {
      const sdkKey = readSdkKey();

      initialization = import('@configcat/sdk').then(async (configCat) => {
        const client = configCat.getClient(sdkKey, configCat.PollingMode.ManualPoll, {
          requestTimeoutMs: REQUEST_TIMEOUT_MS,
          logger: configCat.createConsoleLogger(configCat.LogLevel.Error)
        });
        const refresh = await client.forceRefreshAsync();

        if (!refresh.isSuccess) throw new Error(refresh.errorMessage);

        sdk = {
          User: configCat.User,
          snapshot: client.snapshot()
        };
      });
    }

    return initialization;
  },

  async getValue(key, defaultValue, targeting = {}) {
    if (!sdk) return defaultValue;

    const user = targeting.identifier
      ? new sdk.User(targeting.identifier)
      : undefined;

    return sdk.snapshot.getValue(key, defaultValue, user);
  }
};
